var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import "./styles.scss";
import { Image } from "@react-components/primitives/Image/Image";
import { BREAKPOINTS } from "@styles/breakpoints";
import { generateImageSources } from "@react-components/primitives/UmbracoImage/imageProcessor/generateImageSources";
import { useInView } from "react-intersection-observer";
import { AspectRatio } from "@react-components/primitives/AspectRatio/AspectRatio";
import useBreakpoint from "../../../hooks/use-breakpoint/use-breakpoint";
import { LazyMotion, domAnimation, m } from "framer-motion";
import { ConditionalWrap } from "@react-components/primitives/ConditionalWrap/ConditionalWrap";
export var UMBRACO_IMAGE_RESOLUTIONS = [1, 1.5, 2];
var getBreakpointValue = function (array, index) {
    var value = array[index];
    if (value)
        return value;
    return getBreakpointValue(array, index - 1);
};
var UmbracoImage = function (_a) {
    var _b;
    var width = _a.width, height = _a.height, image = _a.image, alt = _a.alt, useRatio = _a.useRatio, otherProps = __rest(_a, ["width", "height", "image", "alt", "useRatio"]);
    var ratioModifier = height ? " umbraco-image--aspect-ratio" : "";
    var _c = useInView({ triggerOnce: true, threshold: 0 }), ref = _c.ref, inView = _c.inView;
    var breakpoint = useBreakpoint(BREAKPOINTS).breakpoint;
    var breakPointIndex = useMemo(function () {
        return Object.entries(BREAKPOINTS).findIndex(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key === breakpoint;
        });
    }, [breakpoint]);
    var currentWidth = useMemo(function () { return width && getBreakpointValue(width, breakPointIndex); }, [breakPointIndex, width]);
    var currentHeight = useMemo(function () { return height && getBreakpointValue(height, breakPointIndex); }, [breakPointIndex, height]);
    if (!image) {
        return null;
    }
    if (!(width === null || width === void 0 ? void 0 : width[0]) || (!(width === null || width === void 0 ? void 0 : width[0]) && !(height === null || height === void 0 ? void 0 : height[0]))) {
        console.error("First item in Width/Height collection must be defined as something else than 0/null");
    }
    var _d = __read(generateImageSources(image, UMBRACO_IMAGE_RESOLUTIONS, Object.values(BREAKPOINTS), width, height)), firstImageSource = _d[0], remainingImageSources = _d.slice(1);
    return (_jsxs("div", __assign({ className: "umbraco-image" + ratioModifier, ref: ref }, { children: [_jsx("div", { className: "umbraco-image__bg", "aria-hidden": "true" }, void 0), _jsx(ConditionalWrap, __assign({ condition: !!height && !!useRatio, wrap: function (children) { return (_jsx(AspectRatio, __assign({ ratio: currentWidth / currentHeight }, { children: children }), void 0)); } }, { children: _jsx(LazyMotion, __assign({ features: domAnimation }, { children: inView && (_jsx(m.div, __assign({ initial: { opacity: 0 }, animate: { opacity: 1 } }, { children: _jsxs("picture", { children: [remainingImageSources === null || remainingImageSources === void 0 ? void 0 : remainingImageSources.reverse().map(function (_a, index) {
                                    var srcSet = _a.srcSet, media = _a.media;
                                    return (_jsx(React.Fragment, { children: _jsx("source", { srcSet: srcSet, media: media }, void 0) }, srcSet + "-" + index));
                                }), _jsx(Image, __assign({ src: image.url, srcSet: firstImageSource === null || firstImageSource === void 0 ? void 0 : firstImageSource.srcSet, className: "image", alt: (_b = alt !== null && alt !== void 0 ? alt : image.alt) !== null && _b !== void 0 ? _b : image.name }, otherProps), void 0)] }, void 0) }), void 0)) }), void 0) }), void 0)] }), void 0));
};
export { UmbracoImage };
